import styled from 'styled-components';

const Layout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export default Layout;
